import styled from 'styled-components';

export const DropdownMenu = styled.div`
  padding: 10px;
  border-radius: 8px;
  position: absolute;
  right: 0;
  top: 120%;
  z-index: 5002;
  background-color: ${(p) => p.theme.colors.primary.white};
  min-width: 14rem;
  transition: all 0.5s;
  scrollbar-width: thin;
  -webkit-box-shadow: 0px 2px 5px 3px ${(p) => p.theme.colors.primary.textDarkGrey};
  box-shadow: 0px 2px 5px 3px ${(p) => p.theme.colors.primary.textDarkGrey}80;
  overflow-y: auto;
`;

export const MenuElement = styled.div`
  display: flex;
  align-items: center;
  border-bottom: ${(p) => (p.hasBorder ? `1px solid ${p.theme.colors.primary.lightGrey}` : '')};
  cursor: pointer;
  user-select: none;
  color: ${(p) => p.color};
`;

export const MenuLabel = styled.p`
  color: inherit;
  text-align: center;
  margin: 10px;
`;

export const SidebarStyle = styled.div`
  flex-direction: column;

  div {
    display: flex;
    border-bottom: 1px solid ${(p) => p.theme.colors.primary.navbarElementBorderBottom}94;
    cursor: pointer;
    height: 3rem;
    line-height: 2rem;
  }

  .externalEntry {
    line-height: 3rem;
    display: flex;
    justify-content: space-between;

    p {
      margin-right: auto;
    }

  }

  .subMenuEntry-active {
    padding-left: 4rem;
    line-height: 3rem;
    font-size: 0.85rem;
    display: flex;
    justify-content: space-between;


  p {
      color: ${(p) => p.theme.colors.primary.navbarActiveColor};
    }
  }

  .subMenuEntry-deactive {
    display: none;
  }
  
  .icon-arrow-2, .icon-arrow-up{
    font-size: 0.8em !important;
  }
`;

export const Arrow = styled.span`
  font-size: 15px;
  padding: 0.5em 0;
  
  :before {
    color: ${(p) => p.theme.colors.accent.primary};
  }
  padding: 0.5em 0;
  right: 0;
  position: absolute;
`;

export const PlusTextWrapper = styled.div`
  width:100%;
  height:40px;
  display:flex;
  align-items:center;
  cursor: ${(p) => (p.enabled ? 'pointer' : 'not-allowed')};
  opacity: ${(p) => !p.enabled && '50%'};
  span {
    width: 32px;
    text-align: center;
  }
`;

export const Text = styled.p`
  margin:0 0 0 8px;
  font-size:16px;
  font-weight: 700;
  color: ${(p) => p.color ?? p.theme.colors.accent.primary};
  white-space: nowrap;
`;
